import React from 'react';
import BACKCARDS from '../utils/backCardValues';

import 'primeflex/primeflex.css';
import './backPricing.scss';

import BackComparison from '../components/BackComparison';
import BackGettingStarted from '../components/BackGettingStarted';
import BackBeforeStarted from '../components/BackBeforeStarted';
import BackPrimeCard from '../components/BackPrimeCard';

function FrontPricing() {
  return (
    <>
      <div className="backPricing--container">
        <div id="backContainer">
          <div className="grid justify-content-center">
            {Object.values(BACKCARDS).map(card => (
              <BackPrimeCard
                key={card.title}
                title={card.title}
                description={card.description}
                priceText={card.priceText}
                price={card.price}
                checklistP={card.checklistP}
                buttonLabel={card.buttonLabel}
                icon={card.icon}
                headerStyle={card.headerStyle}
                priceStyle={card.priceStyle}
                keyFeature={card.keyFeature}
              />
            ))}
          </div>
        </div>
      </div>
      <div>
        <BackComparison />
      </div>
      <div>
        <BackGettingStarted />
      </div>
      <div>
        <BackBeforeStarted />
      </div>
    </>
  );
}

export default FrontPricing;
